import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';

import Verifyemail from "Pages/Verifyemail";


const Verifyemailtheme = () => {
  const { t } = useTranslation();

  return (
    <section className="common_sign_main sign_in p-3">
      <Container fluid>
      <Row>
      <Col lg={5} md={6} sm={12} className="order-2 order-lg-1">
       <Verifyemail/>
      </Col>

      <Col lg={7} md={6} sm={12} className="order-1 order-lg-2">

<div className="right_gradient_part position-relative">

  <Link to="/" className="logo">
    <img src="images/logo.svg" alt="logo" className="img-fluid" />
  </Link>

  <div className="signingimg_bottom">
    <img
      src="/images/signinimg.png"
      alt=""
      className="img-fluid"
    />
  </div>

  <div className="right_gradient_text">
    <h4>{t('track_crypto')}</h4>
    <p>
     {t('login_ispublish')}
    </p>
  </div>
</div>

</Col>
      </Row>
       </Container>
    </section>
    
  );
};

export default Verifyemailtheme;
